import React, { createContext, ReactNode, useContext, useState } from 'react'
import { useAppSelector } from 'src/hooks'
import { selectUserEnvironmentDataList } from 'src/redux'

interface RatesContextProps {
  environmentId: string | undefined
  setEnvironmentId: (id: string) => void
  loading: boolean
}

const RatesContext = createContext<RatesContextProps>({} as RatesContextProps)

const RatesContextProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const userEnvironmentDataList = useAppSelector(selectUserEnvironmentDataList)

  const [environmentId, setEnvironmentId] = useState<string | undefined>(() =>
    userEnvironmentDataList.length === 1
      ? userEnvironmentDataList[0].id
      : undefined
  )
  const [loading, setLoading] = useState(false)

  const setEnvironment = (id: string | undefined) => {
    setEnvironmentId(id)
  }

  return (
    <RatesContext.Provider
      value={{ setEnvironmentId: setEnvironment, environmentId, loading }}
    >
      {children}
    </RatesContext.Provider>
  )
}
export default RatesContextProvider
export const useRatesContext = () => useContext(RatesContext)
